module.exports = __webpack_public_path__ + "media/images/athletes/2888-5a7ff67f1ef989c50f01311770dd5b57.png";